var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Carousel } from 'primereact/carousel';
import { Row } from '../Grid';
import { AiOutlineCamera } from 'react-icons/ai';
export var LazyLoadCarrousel = function (_a) {
    var images = _a.images, alt = _a.alt, height = _a.height, width = _a.width, minHeight = _a.minHeight, minWidth = _a.minWidth, maxHeight = _a.maxHeight, maxWidth = _a.maxWidth, iconSize = _a.iconSize, iconColor = _a.iconColor, iconClasses = _a.iconClasses, circle = _a.circle, className = _a.className, props = __rest(_a, ["images", "alt", "height", "width", "minHeight", "minWidth", "maxHeight", "maxWidth", "iconSize", "iconColor", "iconClasses", "circle", "className"]);
    var ImageTemplate = function (src) { return _jsx(LazyLoadImage, __assign({}, props, { className: "".concat(circle ? 'br-a-50' : '', " ").concat(className || ''), alt: alt, height: height, src: src, width: width, style: __assign({ minHeight: minHeight, minWidth: minWidth, maxHeight: maxHeight, maxWidth: maxWidth }, props.style) })); };
    if (images && images.hasRows()) {
        return (_jsx("div", __assign({ className: "images-carousel" }, { children: _jsx(Carousel, { value: images, itemTemplate: ImageTemplate, numVisible: 1, numScroll: 1 }) })));
    }
    else {
        return (_jsx(Row, __assign({ justify: "center", align: "center", style: __assign({ width: width, height: height, minHeight: minHeight, minWidth: minWidth, maxHeight: maxHeight, maxWidth: maxWidth }, props.style) }, { children: _jsx("div", __assign({}, props, { className: "".concat(circle ? 'br-a-50' : '', " ").concat(className || '', " pa-2") }, { children: _jsx(AiOutlineCamera, { className: "".concat(iconColor ? iconColor : "t-surface-6", " ").concat(iconClasses || ''), size: iconSize || 32 }) })) })));
    }
};
export default LazyLoadCarrousel;
